import { render, staticRenderFns } from "./SMenuButton.vue?vue&type=template&id=1ee0919b&lang=pug"
import script from "./SMenuButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMenuButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports